export const basePathUtils = "utils/";
export const nameManual = "Manuel-Optiwize.pdf";
